export default {
  STUDIO_URL: 'https://studio-staging.conversional.de/',
  ROOT_URL: 'https://cloud-staging.conversional.de',
  WS_URL: 'soketi.conversional.de',
  sentry: 'https://6a99474d26cb411395b5f81a07eba4c8@o236458.ingest.sentry.io/1452146',
  GA_ID: '',
};
